"use client"
import { Form } from "react-bootstrap"

const YearRangeSelector = ({ value, onChange }) => {
  const options = [
    { value: 1, label: "Last Year" },
    { value: 2, label: "Average of 2 Years" },
    { value: 5, label: "Average of 5 Years" },
    { value: 7, label: "Average of 7 Years" },
    { value: 10, label: "Average of 10 Years" },
  ]

  return (
    <div className="d-flex align-items-center">
      <Form.Label className="me-2 mb-0 text-nowrap">Weather Period:</Form.Label>
      <Form.Select
        size="sm"
        value={value}
        onChange={(e) => onChange(Number.parseInt(e.target.value))}
        style={{ width: "200px" }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </div>
  )
}

export default YearRangeSelector
